<template>
<div class="micro-course-wrapper">
    <ctl-header title="课程列表" :onBack="onBack">
        <div class="my-course" slot="right" @click="goMy">我的课程</div>
    </ctl-header>
    <van-tabs v-model="classifyId" animated color="#53CB85" swipe-threshold="3" style="background: #FAFAFA" title-active-color="#53CB85" @change="getList(1)">
        <van-tab title="全部" name=""></van-tab>
        <van-tab v-for="(v,i) in classifyIdList" :key="i" :title="v.name" :name="v.id"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshLoading" @refresh="()=>{this.getList(1)}">
        <!-- 列表 -->
        <van-list
            v-if="list.length > 0"
            v-model="loading"
            :error-text="'请求失败， 点击重新加载'"
            :error.sync="error"
            :finished="finished"
            finished-text="没有更多了"
            @load="getList()"
        >
            <div class="card" v-for="(v,i) in list" :key="i" @click="goDetail(v)">
                <div class="card-cover">
                    <img :src="v.picture" alt="">
                </div>
                <div class="card-name">{{v.courseName}}</div>
                <div class="card-info">
                    <div class="type">{{v.payConPrice? `¥${v.payConPrice}` : (v.payOrigPrice ? v.payOrigPrice : '免费')}}</div>
                    <div class="watch"><van-icon size="16" name="eye-o" />{{v.viewCount}}</div>
                </div>
                <img class="card-type" v-if="v.type === 2" src="@/assets/microCourse/kclb_img_xlkbq.png">
            </div>
        </van-list>
        <div v-else class="none-order">
            <img alt="" src="@/assets/order/picture_noorder.png">
            <p>暂无数据</p>
        </div>
    </van-pull-refresh>
</div>
</template>

<script>
import { Button, List, PullRefresh, Tab, Tabs, Toast, Icon } from 'vant'
export default {
    components: {
        [List.name]: List,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Button.name]: Button,
        [Toast.name]: Toast,
        [Icon.name]: Icon,
        [PullRefresh.name]: PullRefresh
    },
    name: 'microCourseIndex',
    data () {
        return {
            classifyId: '',
            cityCode: '',
            list: [],
            classifyIdList: [],
            pageData: {
                current: 1,
                size: 5
            },
            refreshLoading: false,
            loading: false,
            error: false,
            finished: false
        }
    },
    created () {
        // 暴露刷新页面方法
        this.$jsBridge.registerHandler('refreshCallBack', () => {
            // 注入token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')
            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }
        })
        // 设置城市code
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode
        this.courseClassify()
        this.getList(1)
    },
    methods: {
        // 返回
        onBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 跳转我的课程
        goMy () {
            // 获取用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')
            userInfo = userInfo ? JSON.parse(userInfo) : {}
            // 没有用户id && 去登录
            if (!userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }
            this.$router.push({ name: 'microCourseMy' })
        },
        // 跳转详情
        goDetail (v) {
            let courseId = v.courseId
            let coverUrl = v.picture
            let courseName = v.courseName
            if (v.type === 1) {
                this.$jsBridge.callBackHandler('pushMicroCourseVideoDetailPage', { courseId, coverUrl, courseName })
            } else {
                this.$router.push({ name: 'seriesCourse', query: { id: courseId } })
            }
        },
        // 课程分类
        courseClassify () {
            this.$api.mycourseClassify().then(res => {
                if (res.status) {
                    this.classifyIdList = res.result
                }
            })
        },
        // 获取数据
        getList (refresh) {
            if (refresh) {
                this.pageData.current = 1
            }
            const postData = Object.assign({ classifyId: this.classifyId, cityCode: this.cityCode }, this.pageData)
            this.$api.getMoreCourses(postData).then(res => {
                setTimeout(() => {
                    Toast.clear()
                }, 500)
                if (res.status) {
                    if (refresh) {
                        this.list = res.result.records
                    } else {
                        this.list.push(...res.result.records)
                    }
                    this.pageData.current++
                    this.finished = res.result.records.length < this.pageData.size // 首次加载的数据不能铺满屏幕， 设置加载完毕状态， 不再触发load
                } else {
                    this.error = true
                }
                this.refreshLoading = false
                this.loading = false
            })
        }
    }
}
</script>

<style scoped lang="scss">
.micro-course-wrapper{
    .card{
        position: relative;
        background: #FFFFFF;
        box-shadow: 0 0 5px 0 rgba(0,0,0,0.05);
        border-radius: 5px;
        padding: 15px;
        margin: 0 0 10px 0;
        .card-cover{
            width: 325px;
            height: 210px;
            border-radius: 5px;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .card-type{
            width: 64px;
            position: absolute;
            right: 0;
            top: 0;
        }
        .card-name{
            margin: 9px 0 0 0;
            line-height: 1;
            font-size: 15px;
            color: #333333;
        }
        .card-info{
            margin: 12px 0 0 0;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 13px;
            color: #999999;
            .type{
                color: #FF5050;
            }
            .watch{
                display: flex;
                align-items: center;
                .van-icon{
                    margin: 0 5px 0 0;
                }
            }
        }
    }
    .van-tabs{
        width: 100%;
    }
    .van-pull-refresh{
        width: 100%;
        box-sizing: border-box;
        padding: 10px 10px 0;
        background: #fafafa;
        height: calc(100vh - 98px);
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }
    .none-order {
        text-align: center;
        img {
            margin-top: 150px;
            width: 150px;
            margin-bottom: 38px;
        }

        p {
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
        }
    }
}

/deep/ {
    .van-tab--active .van-tab__text--ellipsis,.van-tab--active .van-tab__text {
        font-size: 15px;
    }
    .van-tab__text--ellipsis,.van-tab__text {
        font-size: 13px;
    }
}
</style>
